module.exports = __webpack_public_path__ + "img/5.1177db0f.jpg";